var render = function () {
  var _vm$currentStep, _vm$currentStep$answe, _vm$currentStep$answe2, _vm$currentStep2, _vm$currentStep2$answ, _vm$currentStep2$answ2, _vm$currentRound;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'paragraph-centered'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(_vm$currentStep = _vm.currentStep) !== null && _vm$currentStep !== void 0 && (_vm$currentStep$answe = _vm$currentStep.answerImage) !== null && _vm$currentStep$answe !== void 0 && (_vm$currentStep$answe2 = _vm$currentStep$answe.image) !== null && _vm$currentStep$answe2 !== void 0 && _vm$currentStep$answe2.src ? _c('figure', [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto"
    },
    attrs: {
      "alt": "Background image",
      "src": (_vm$currentStep2 = _vm.currentStep) === null || _vm$currentStep2 === void 0 ? void 0 : (_vm$currentStep2$answ = _vm$currentStep2.answerImage) === null || _vm$currentStep2$answ === void 0 ? void 0 : (_vm$currentStep2$answ2 = _vm$currentStep2$answ.image) === null || _vm$currentStep2$answ2 === void 0 ? void 0 : _vm$currentStep2$answ2.src
    }
  })]) : _vm._e(), _vm._l((_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.steps, function (step, stepIndex) {
    return _c('div', {
      key: stepIndex,
      staticClass: "text-container",
      class: _vm.getTextClasses
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": step.answer,
        "text-step": stepIndex
      }
    })], 1);
  })], 2)], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }